module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match__list"
  }, [_c('div', {
    staticClass: "match__box user-dice",
    class: _vm.isActive
  }, [_c('div', {
    staticClass: "match__item"
  }, [_c('p', {
    staticClass: "match__text"
  }, [_vm._v("あなたのサイコロ")]), _vm._v(" "), _c('vue-audio', {
    ref: "clickBtn",
    attrs: {
      "file": 3
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: _vm.btnStart,
    on: {
      "click": _vm.shakeDice
    }
  }, [_c('span', [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isStart),
      expression: "!isStart"
    }],
    staticClass: "txt_stop_race",
    attrs: {
      "src": require("../assets/image/txt_stop_raceScreen.png"),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isStart),
      expression: "isStart"
    }],
    attrs: {
      "src": require("../assets/image/txt_match.png"),
      "alt": ""
    }
  })]), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "match__item"
  }, [_c('dice', {
    attrs: {
      "id": "userDiceL"
    }
  }), _vm._v(" "), _c('dice', {
    attrs: {
      "id": "userDiceS"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "match__box pc-dice",
    class: _vm.pcDiceStatus && !_vm.showRaceTextGoal ? 'active' : ''
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "match__item"
  }, [_c('dice', {
    attrs: {
      "id": "pcDiceL"
    }
  }), _vm._v(" "), _c('dice', {
    attrs: {
      "id": "pcDiceS"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match__item"
  }, [_c('p', {
    staticClass: "match__text"
  }, [_vm._v("対戦相手のサイコロ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ed01cc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MatchDice.vue
// module id = 83
// module chunks = 0